import type { Accent } from "@dfws/contracts";

export interface AccentOption {
  id: Accent;
  label: string;
  /** Primary in each theme, for the picker swatch. accents.test.ts keeps these equal to the CSS. */
  swatch: { light: string; dark: string };
}

export const accents: AccentOption[] = [
  { id: "purple", label: "Purple", swatch: { light: "#8b3fc7", dark: "#a855f7" } },
  { id: "wine", label: "Wine", swatch: { light: "#8a1c3a", dark: "#e86f8e" } },
  { id: "ocean", label: "Ocean", swatch: { light: "#1f5fb8", dark: "#6aa1ff" } },
  { id: "forest", label: "Forest", swatch: { light: "#1e7a46", dark: "#4cc787" } },
  { id: "teal", label: "Teal", swatch: { light: "#0f7480", dark: "#3cc4cf" } },
  { id: "slate", label: "Slate", swatch: { light: "#475569", dark: "#a3b1c6" } },
  { id: "amber", label: "Amber", swatch: { light: "#9a5800", dark: "#f0a54a" } },
];
